import DuplicateEntityAlert from './DuplicateEntityAlert';

export default DuplicateEntityAlert;
